// Shared vocabulary for the three content types

export const KINDS = ["stamp", "cover", "article"];

export const KIND_PATHS = {
  stamp: "stamps",
  cover: "covers",
  article: "articles",
};

export const KIND_LABELS = {
  stamp: "Stamp",
  cover: "First-day cover",
  article: "Article",
};

// Tile formats selectable per item; first entry is the default
export const TILE_VARIANTS = {
  stamp: [
    { value: "image", label: "Image only (portrait)" },
    { value: "card", label: "Card — stamp + title + year" },
  ],
  cover: [
    {
      value: "landscape",
      label: "Landscape — full envelope, with label (2 columns)",
    },
    { value: "landscape-image", label: "Landscape — image only (2 columns)" },
    { value: "portrait", label: "Portrait — design detail, with label" },
    { value: "portrait-image", label: "Portrait — image only" },
  ],
  article: [
    { value: "standard", label: "Standard text card" },
    { value: "wide", label: "Wide text card (2 columns)" },
    { value: "image", label: "Image only (portrait)" },
    { value: "image-card", label: "Image card — image + title overlay" },
  ],
};

export function defaultVariant(kind) {
  return TILE_VARIANTS[kind]?.[0].value || "";
}

export function tileVariantOf(item) {
  const allowed = TILE_VARIANTS[item.kind]?.map((v) => v.value) || [];
  return allowed.includes(item.tileVariant)
    ? item.tileVariant
    : defaultVariant(item.kind);
}

export function itemPath(item) {
  return `/${KIND_PATHS[item.kind] || "stamps"}/${item.catalogue_id}`;
}

// Rough plain-text rendering of the markdown description, for tile summaries
export function plainDescription(markdown = "") {
  return markdown
    .replace(/\[([^\]]*)\]\([^)]*\)/g, "$1")
    .replace(/[*_`>#]/g, "")
    .replace(/\s+/g, " ")
    .trim();
}

export function readingTime(markdown = "") {
  const words = plainDescription(markdown).split(" ").filter(Boolean).length;
  return `${Math.max(1, Math.round(words / 200))} min read`;
}
